/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TimeUse } from './timeUse';


export interface StatusCodeValueTimeUse { 
    value?: TimeUse;
    status_code?: number;
}

